// extracted by mini-css-extract-plugin
export var emptyState = "_6j-d";
export var statCard = "_6j-c";
export var table = "_6j-0";
export var tableCell = "_6j-4";
export var tableCellClickable = "_6j-5 _6j-4";
export var tableCellDefault = "_6j-6 _6j-4";
export var tableCellEmpty = "_6j-8";
export var tableCellWithValue = "_6j-7";
export var tableContainer = "_6j-e";
export var tableHeaderWeight = "_6j-1";
export var tableHeaderZone = "_6j-2";
export var tableRowHeader = "_6j-3";
export var viewModeButton = "_6j-9";
export var viewModeButtonActive = "_6j-a _6j-9";
export var viewModeButtonInactive = "_6j-b _6j-9";